<script setup lang="ts">
import { X, SquareCheck } from 'lucide-vue-next';

withDefaults(defineProps<{ loading?: boolean }>(), { loading: false });

const store = useAirlinesFilterStore();
</script>

<template>
  <UiCustomFilterCheckboxGroupSkeleton v-if="loading" />
  <template v-else>
    <UiCustomFilterSectionHeader :label="$t('components.results.filters.airlinesForAllFlights')">
      <UiButton
        variant="tertiary"
        color="gray"
        padding="none"
        class="w-fit gap-1 text-xs font-normal text-gray-600 [&_svg]:size-3.5"
        @click="store.toggleAll"
      >
        <component
          :is="store.allSelected ? X : SquareCheck"
          class="h-5 w-5"
          aria-hidden="true"
        />
        {{
          store.allSelected ? $t('components.results.filters.deselectAll') : $t('components.results.filters.selectAll')
        }}
      </UiButton>
    </UiCustomFilterSectionHeader>
    <ResultsFiltersCheckboxGroup
      @toggle="store.toggle"
      @solo="store.solo"
    />
  </template>
</template>
